import { BaseState } from "../../consts/base-state";
import { TFunction } from "i18next";

const defaultName = "%%%アカウント%%%";

const ServiceNameHash = {
  default: defaultName,
  ttzk: "%%%くらしのてつづき%%%",
  smart: "%%%スマート申請%%%",
  "booth-reserve": "%%%ネット予約%%%",
  "console-graffer-staff": "%%%スマート申請管理画面%%%",
  "registry-certs": "%%%法人証明書請求%%%",
  "e-cert": "%%%電子証明書取得サポート%%%",
  // コーポレートサイトはグラファーに来ていることを期待しているので、個別サービス名は表示しない
  "corporate-site": "",
  dashboard: "%%%ダッシュボード%%%",
  // 手続き検索においては、押し出しているサービス名がいまのところないので、素直に"アカウント"とする
  "proc-search": defaultName,
} as const;

type ServiceNameStateLiterals = keyof typeof ServiceNameHash;

export class ServiceNameState extends BaseState<ServiceNameStateLiterals> {
  static create(value: string): ServiceNameState | undefined {
    // guard prototype pollution attack
    if (!ServiceNameHash.hasOwnProperty(value)) {
      return;
    }
    return new ServiceNameState(value as ServiceNameStateLiterals);
  }
  static createDefault(): ServiceNameState {
    return new ServiceNameState("default");
  }
  getName(t: TFunction) {
    const name = ServiceNameHash[this.getValue()] as string;
    return name ? t(name) : "";
  }
}
